module.exports = __webpack_public_path__ + "img/20180815_151844_207.8d5424eb.jpg";